import { createContext, useMemo } from 'react' // Add useMemo import

import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { Loader } from '@percent/lemonade'
import { useQuery } from '@percent/partner-dashboard/common/hooks'
import { PartnerConfigContextType, PartnerConfigProviderProps } from './PartnerConfigProvider.types'

export const PartnerConfigContext = createContext<PartnerConfigContextType | undefined>(undefined)

export function PartnerConfigProvider({ children, partnerConfigKey }: PartnerConfigProviderProps) {
  const { partnerService } = useServices()
  const [{ data, isLoading, error }] = useQuery(partnerService.getConfig, partnerConfigKey)

  const contextValue = useMemo(
    () => ({
      configData: data,
      isConfigError: error
    }),
    [data, error]
  )

  if (isLoading) {
    return <Loader />
  }

  return <PartnerConfigContext.Provider value={contextValue}> {children}</PartnerConfigContext.Provider>
}
